import { render, staticRenderFns } from "./AccountSecurityReset2fa.vue?vue&type=template&id=0a1e62f4&scoped=true"
import script from "./AccountSecurityReset2fa.vue?vue&type=script&lang=js"
export * from "./AccountSecurityReset2fa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1e62f4",
  null
  
)

export default component.exports